import { lightTheme, resourcesColors, typographyFontFamily } from '@all-manager/design-system-v2/theme';
import {
  ArcElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, ArcElement);

ChartJS.defaults.font.family = typographyFontFamily;
ChartJS.defaults.color = lightTheme.palette.text.secondary;
ChartJS.defaults.borderColor = lightTheme.palette.divider;

/** Categorical series colors, taken from the resource hues of the design system. */
const SERIES_COLORS = [
  resourcesColors.providers.main,
  resourcesColors.rappel.main,
  resourcesColors.rendezVous.main,
  resourcesColors.documents.main,
  resourcesColors.communications.main,
  resourcesColors.task.main,
  resourcesColors.incident.main,
  resourcesColors.autre.main,
];

export function getSeriesColor(index: number) {
  return SERIES_COLORS[index % SERIES_COLORS.length];
}

/** Separates pie slices with the card surface. */
export const SLICE_BORDER_COLOR = lightTheme.palette.background.paper;
